import { instance } from '../instance';

export const listFSM = (param) => instance.post('fsm/list', param);

export const getFSMDetail = (param) => instance.post('fsm/detail', param);

export const reactiveFSM = (param) => instance.post('fsm/activate', param);

export const inactiveFSM = (param) => instance.post('fsm/inactivate', param);
